// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".product-grid-section{padding:7vw 0 125px}@media (min-width:1024px){.product-grid-section{padding:2vw 0 250px}}", ""]);
// Exports
module.exports = exports;
